module.exports = __webpack_public_path__ + "img/video.9388dc45.png";